<template>
  <v-footer>
    <v-spacer></v-spacer>
    <div>
      Propulsé par
      <v-btn class="pa-0" link href="https://ca.eudonet.com/" elevation="0">Eudonet</v-btn>
      &copy;
    </div>
  </v-footer>
</template>

<script>
export default {}
</script>

<style>
</style>